export default {
    accessKeyConstants: {
        accessKeys: {
            DefaultKey: "00000000-0000-0000-0000-000000000000",
        },
        default: "DefaultKey",
        requestTypes: [
            "AppeventRequest",
            "ConverseRequest",
            "RequestUnitRequest",
            "ReportingRequest",
        ],
        usesAccessKey: true,
    },
};



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/settings/access-key.ts